import { type SxProps, type Theme } from "@mui/material";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";

import * as Styled from "./PlanGiftIcon.styles";
import { usePlanGiftIcon } from "./usePlanGiftIcon";

interface IPlanGiftIconProps {
  sx?: SxProps<Theme>;
}

export const PlanGiftIcon: FC<IPlanGiftIconProps> = ({ sx }) => {
  const { tooltip } = usePlanGiftIcon();

  if (!tooltip) {
    return null;
  }

  return (
    <RichTooltip title={tooltip} actionText="">
      <Styled.GiftIcon sx={sx} />
    </RichTooltip>
  );
};
